<script>
  import { onMount, createEventDispatcher } from 'svelte';

  import { getContractType, getContractValue } from '../utils.js';
  import { ipfsParts, isZeroIndex, ipfs2http } from '../ipfs.js';

  import Gallery from 'lt-gallery';

  export let chain;
  export let address;
  export let layouts;
  export let selected = [];

  let items;

  const init = async () => {
    if (typeof layouts === 'string') {
      const resp = await fetch(layouts);
      if (resp.ok) {
        layouts = await resp.json();
      }
    }

    let [contractType, tokensAmount, uri] = await Promise.all([
      getContractType(address, chain),
      getContractValue(chain, address, 'tokensAmount'),
      getContractValue(chain, address, 'uri', [ 0 ])
    ]);
    tokensAmount = Number(tokensAmount);

    const jsons = [];
    const { cId } = ipfsParts(uri);
    const pad = await isZeroIndex(cId) ? 0 : 1;
    for (let idx = 0; idx < tokensAmount; idx++) {
      const json = await ipfs2http(uri.replace('{id}', idx + pad));
      json.chain = chain;
      json.contract = address;
      json.contractType = contractType;
      jsons.push(json)
    }
    items = jsons;
  }

  onMount(init);

  const dispatch = createEventDispatcher();
</script>

{#if items}
  <Gallery { layouts } { items } bind:selected={ selected } on:message={ ({ detail }) => { dispatch('message', detail) } } on:select={ ({ detail }) => { dispatch('select', detail) } } on:deselect={ ({ detail }) => { dispatch('deselect', detail) } } />
{:else}
  Loading...
{/if}